import React from 'react'
import { FormattedMessage } from 'react-intl'
import Dialog from '@material-ui/core/Dialog'
import '../styles/signInOtherDialog.scss'

export default function SignInOtherDialog({ open }) {
    return (
        <Dialog className="sign-in-other-dialog" open={open}>
            <div className="title">
                <FormattedMessage id="signInOther" />
            </div>
            <div className="content">
                <FormattedMessage id="signInOtherDetail" />
            </div>
        </Dialog>
    )
}
